import React, { useState, useRef, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import InputClientUploadFiles, {
  SimpleInputTextWithKeyboard,
} from "../clavie/InputClientUPloadfiles";
import ImageCard from "../imageGallery/ImageGallrey";
import axios from "axios";
import { api_base } from "../../env";
import PopupChangeBg from "../Popup/PopupChangeBg";
const TimeCamera = ({
  setCapturedBlob,

  handleConfirm,
  cadrage,
  displayText = false,
  setSrcRm,
  srcRm,
  setBackground,
  Background,
  text,
  setText,
  removeBg = false,
  setColor,
  color = "#ffffff",
  multiple = false,
  type,
  backgroundUrls = [],
  setLoading,
  idEvent = null,
}) => {
  console.log("TimeCamera multiple:", multiple);

  console.log("  Background :", Background);
  console.log("srcRm :", srcRm);
  const videoRef = useRef(null);

  const [capturedImages, setCapturedImages] = useState([]);

  const [capturedImage, setCapturedImage] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [error, setError] = useState(null);
  const [videoSize, setVideoSize] = useState({ width: 640, height: 480 });
  const canvasRef = useRef(null);
  const [indexImageChangeBg, SetIndexImageChangeBg] = useState();
  const [PopupChangeBgEtat, setPopupChangeBgEtat] = useState(false);

  console.log("cadrage    :", cadrage);
  const isMulti = multiple && Number(multiple) > 1;
  const maxPhotos = isMulti ? Number(multiple) : 1;
  const canTakeMore = isMulti
    ? capturedImages.length < maxPhotos
    : !capturedImage;
  useEffect(() => {
    let streamRef = null;
    const startWebcam = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        streamRef = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            setVideoSize({
              width: videoRef.current.videoWidth,
              height: videoRef.current.videoHeight,
            });
          };
        }
      } catch (err) {
        console.error("Error accessing webcam:", err);
        setError("Impossible d'accéder à la caméra");
      }
    };
    if (canTakeMore) {
      startWebcam();
    }
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
      if (streamRef) {
        streamRef.getTracks().forEach((track) => track.stop());
      }
    };
  }, [canTakeMore]);

  const takePhoto = async () => {
    try {
      const res = await fetch("http://localhost:5002/api/capture");
      if (!res.ok) throw new Error("Capture failed");

      const blob = await res.blob();
      setCapturedBlob(blob);

      if (capturedImage) URL.revokeObjectURL(capturedImage);

      const imageUrl = URL.createObjectURL(blob);
      setCapturedImage(imageUrl);
      setError(null);
    } catch (err) {
      console.error("Error capturing photo:", err);
      setError("Erreur lors de la capture");
    }
  };
  /*
  const takePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (!canvas || !video) return;

    canvas.width = video.videoWidth || 640;
    canvas.height = video.videoHeight || 480;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      if (blob) {
        const imageUrl = URL.createObjectURL(blob);
        if (isMulti) {
          setCapturedImages((prev) => {
            const updated = [...prev, { blob, url: imageUrl }];
            setCapturedBlob(updated.map((img) => img.blob));
            return updated;
          });
        } else {
          const newImg = { blob, url: imageUrl };
          setCapturedBlob(blob);
          setCapturedImage(newImg);
        }
      }
    }, "image/jpeg");
  };*/
  const startCountdownAndCapture = () => {
    let counter = 3;
    setCountdown(counter);
    const interval = setInterval(() => {
      counter -= 1;
      if (counter === 0) {
        clearInterval(interval);
        setCountdown(null);
        takePhoto();
      } else {
        setCountdown(counter);
      }
    }, 1000);
  };

  function RemoveBgAndOpenPopup() {
    const image = capturedImage;

    //  SetIndexImageChangeBg(index);
    if (srcRm) {
      setPopupChangeBgEtat(true);
      return;
    }

    if (!image.blob) {
      alert("Aucune image valide trouvée !");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    const file = new File([image.blob], `camera_${Date.now()}.jpg`, {
      type: "image/jpeg",
    });
    formData.append("image", file);

    sendRemoveBg(formData);
  }

  function sendRemoveBg(formData) {
    axios
      .post(`${api_base}images/RemoveBackground`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const imageUrl = response.data.image;
        setSrcRm(imageUrl);
        setPopupChangeBgEtat(true);
      })
      .catch((error) => console.error("Error removing background:", error))
      .finally(() => setLoading(false));
  }

  const handleCancel = () => {
    if (multiple && Number(multiple) > 1) {
      // Remove all captured images
      capturedImages.forEach((img) => URL.revokeObjectURL(img.url));
      setCapturedImages([]);
    } else {
      if (capturedImage) URL.revokeObjectURL(capturedImage);
      setCapturedImage(null);
    }
    setError(null);
  };

  // Remove a single photo in multi mode
  const handleRemovePhoto = (idx) => {
    setCapturedImages((prev) => {
      const toRemove = prev[idx];
      if (toRemove) URL.revokeObjectURL(toRemove.url);
      return prev.filter((_, i) => i !== idx);
    });
  };

  function handleChangeBg(selectedBg) {
    setBackground(selectedBg);
    setPopupChangeBgEtat(false);
  }

  const getAspectRatio = (cadrage) => {
    switch (cadrage) {
      case "1/1":
        return 1;
      case "3/4":
        return 3 / 4;
      case "4/3":
        return 4 / 3;
      case "16/9":
        return 16 / 9;
      case "9/16":
        return 9 / 16;
      case "2/3":
        return 2 / 3;
      case "3/2":
        return 3 / 2;
      case "5/7":
        return 5 / 7;
      case "7/5":
        return 7 / 5;
      case "29/21":
        return 29.7 / 21;
      case "13/18":
        return 18 / 13;
      case "15/21":
        return 15 / 21;

      default:
        return 1;
    }
  };
  const aspect = getAspectRatio(cadrage);
  let frameWidth = videoSize.width;
  let frameHeight = frameWidth / aspect;
  if (frameHeight > videoSize.height) {
    frameHeight = videoSize.height;
    frameWidth = frameHeight * aspect;
  }
  const handleColorChange = (e) => {
    setColor(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      {/* ------------------ 🥇 STEP 1 : CAPTURE PHASE ------------------ */}
      {!capturedImage && capturedImages.length === 0 && (
        <>
          {/* Video or last image preview */}
          <div
            style={{
              position: "relative",
              width: videoSize.width,
              height: videoSize.height,
            }}
          >
            {canTakeMore ? (
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                  border: "2px solid #ccc",
                  objectFit: "cover",
                }}
              />
            ) : isMulti ? (
              <img
                src={capturedImages[capturedImages.length - 1]?.url}
                alt="Captured"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                  border: "2px solid #ccc",
                  objectFit: "cover",
                }}
              />
            ) : null}
            {/* cadrage frame */}
            {canTakeMore && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: `${frameWidth}px`,
                  height: `${frameHeight}px`,
                  border: "3px dashed red",
                  borderRadius: "8px",
                  pointerEvents: "none",
                  background: "rgba(0,0,0,0.05)",
                }}
              />
            )}

            {/* countdown */}
            {countdown && (
              <div
                style={{
                  position: "absolute",
                  top: "40%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontSize: "72px",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                {countdown}
              </div>
            )}
          </div>

          {/* capture button */}
          {canTakeMore && (
            <div style={{ marginTop: 20 }}>
              <Button
                variant="contained"
                onClick={startCountdownAndCapture}
                disabled={countdown !== null}
                sx={{
                  backgroundColor: "#5a5a5a",
                  color: "#fff",
                  borderRadius: "6px",
                  padding: "12px 24px",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#4a4a4a" },
                }}
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <CheckIcon sx={{ color: "#6cc24a" }} />
                  <Typography sx={{ fontWeight: "bold" }}>
                    JE PRENDS LA PHOTO
                  </Typography>
                </Box>
              </Button>

              {isMulti && (
                <Typography sx={{ mt: 1, fontSize: "0.95rem" }}>
                  {capturedImages.length} / {maxPhotos} photos prises
                </Typography>
              )}
            </div>
          )}
        </>
      )}

      {/* ------------------ 🥈 STEP 2 : EDIT / CONFIRM PHASE ------------------ */}
      {(capturedImage || capturedImages.length > 0) && (
        <div style={{ marginTop: 20, width: "80%" }}>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Box sx={{ width: "40%" }}>
              {isMulti ? (
                <div
                  style={{ display: "flex", gap: 10, justifyContent: "center" }}
                >
                  {capturedImages.map((img, idx) => (
                    <ImageCard
                      key={idx}
                      src={img.url}
                      index={idx}
                      type={type}
                      displayCount={false}
                      DeleteDisplay={false}
                      Rm_bg={false}
                      //changeBackground={RemoveBgAndOpenPopup}
                      //  srcRm={img.srcRm}
                      //  urlBg={img.Bg ? img.Bg.Url : false}
                    />
                  ))}
                </div>
              ) : (
                <ImageCard
                  src={capturedImage.url}
                  type={type}
                  displayCount={false}
                  DeleteDisplay={false}
                  Rm_bg={idEvent ? true : false}
                  changeBackground={RemoveBgAndOpenPopup}
                  srcRm={srcRm}
                  urlBg={Background ? Background.Url : false}
                />
              )}
            </Box>
          </div>

          {/* text + background color section */}
          {displayText && (
            <Box mt={2}>
              {displayText && (
                <SimpleInputTextWithKeyboard
                  text={text}
                  setText={setText}
                  type={idEvent ? "event" : "magasin"}
                  idEvent={idEvent}
                />
              )}

              {type === "identite" && (
                <Box mt={2}>
                  <Typography variant="subtitle2" gutterBottom>
                    Choisir la couleur du fond :
                  </Typography>
                  <Box display="flex" justifyContent="center" gap={2}>
                    <label>
                      <input
                        type="radio"
                        name="bgColor"
                        value="#ffffff"
                        checked={color === "#ffffff"}
                        onChange={handleColorChange}
                      />{" "}
                      Blanc
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="bgColor"
                        value="#808080"
                        checked={color === "#808080"}
                        onChange={handleColorChange}
                      />{" "}
                      Gris
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="bgColor"
                        value="#0000ff"
                        checked={color === "#0000ff"}
                        onChange={handleColorChange}
                      />{" "}
                      Bleu
                    </label>
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {/* action buttons */}
          <Box mt={3} display="flex" justifyContent="center" gap={2}>
            <Button variant="outlined" color="secondary" onClick={handleCancel}>
              Annuler
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (isMulti) {
                  setCapturedBlob(capturedImages.map((img) => img.blob));
                  handleConfirm(capturedImages.map((img) => img.blob));
                } else {
                  setCapturedBlob(capturedImage.blob);
                  handleConfirm();
                }
              }}
            >
              Confirmer
            </Button>
          </Box>
        </div>
      )}

      {/* hidden canvas */}
      <canvas ref={canvasRef} style={{ display: "none" }} />

      {/* popup background changer */}
      <PopupChangeBg
        open={PopupChangeBgEtat}
        onClose={() => setPopupChangeBgEtat(false)}
        imageWithoutBg={srcRm}
        bgList={backgroundUrls}
        onSave={handleChangeBg}
      />
    </div>
  );
};

export default TimeCamera;
